import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient();

export const cleanupQueries = () => {
  return new Promise((resolve) => {
    // Add a safety timeout to prevent hanging
    const timeoutId = setTimeout(() => {
      unsubscribe?.();
      resolve(undefined);
    }, 5000);

    const unsubscribe = queryClient.getQueryCache().subscribe(() => {
      if (!queryClient.isFetching()) {
        unsubscribe();
        clearTimeout(timeoutId);
        resolve(undefined);
      }
    });

    queryClient.clear();
    // Force check immediately in case there were no ongoing fetches
    if (!queryClient.isFetching()) {
      unsubscribe();
      clearTimeout(timeoutId);
      resolve(undefined);
    }
  });
};
